import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const InteriorFinish = ({ value, onChange, label = 'Interior Finish:', disabled = false }) => {
    const defaultValue = value || 'White';
    const [selectedInteriorFinish, setSelectedInteriorFinish] = useState(defaultValue);

   // Call onChange once on mount if value is not provided
    useEffect(() => {
        if (!value) {
            onChange(defaultValue);
        }
    }, []); // empty deps to run only once

    const handleInteriorFinishChange = (e) => {
        setSelectedInteriorFinish(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} disabled={disabled} htmlFor="InteriorFinish">{label}</label>
            <select style={{ display: "none" }}
                disabled={disabled}
                id="InteriorFinish"
                value={selectedInteriorFinish}
                onChange={handleInteriorFinishChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedInteriorFinish === "White" ? "White ✔" : "White"}</option>
                <option value="Gentek">{selectedInteriorFinish === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default InteriorFinish;
